import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { getHistory } from '../utils/historyUtils';
import createRootReducer from './reducers';

const logger: any = createLogger({
    collapsed: true,
    diff: true,
});

const storeEnhancers = ((window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ as typeof compose) || compose;

const store = createStore(
    createRootReducer(getHistory()),
    storeEnhancers(applyMiddleware(routerMiddleware(getHistory()), thunk, logger)),
);
export default store;
